import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { useForm, Controller } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import TextArea from 'Components/Textarea';
import config from 'Config/firebase';
import Select from 'react-select';
import * as Regex from '../regex';

const styles = theme => ({
  header: {
    marginTop: 30,
  },
  selectBox: {
    marginTop: 30,
  },
  textArea: {
    fontSize: 20,
    width: '100%',
    padding: '60px 20px 0 20px',
  },
  textAreaLabel: {
    padding: '0 20px',
  },
  submit: {
    margin: '20px 20px 20px 0',
  },
});

function Contact({ setActiveModal, classes }) {
  const { register, handleSubmit, errors, control } = useForm({
    defaultValues: {},
  });
  const [mailSent, setMailSent] = useState(false);

  const selectOptions = [
    { value: 'customerSupport', label: 'Customer Support' },
    { value: 'business', label: 'A Business Inquiry' },
    { value: 'other', label: 'Something Else' },
  ];

  const exampleRef = useRef(null);

  const onSubmit = async data => {
    try {
      const response = fetch(`${config.functionsURL}/contactUs`, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
    } catch (err) {
      console.warn('Contact server error: ', err);
      alert('Contact connection error');
      return;
    }

    setMailSent(true);
  };

  return (
    <Page>
      <Container component="main" maxWidth="sm">
        <Typography component="h1" variant="h5" className={classes.header}>
          Contact Us
        </Typography>
        {!mailSent ? (
          <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <Controller
              as={<Select options={selectOptions} />}
              rules={{ required: true }}
              control={control}
              variant="contained"
              label="Subject"
              margin="normal"
              name="subject"
              className={classes.selectBox}
              defaultValue={{
                value: 'customerSupport',
                label: 'Customer Support',
              }}
              onChange={([selected]) => {
                // React Select return object instead of value for selection
                return { value: selected };
              }}
            />
            <FormTextField
              fullWidth
              label="Email"
              name="email"
              margin="normal"
              error={!!errors.email}
              helperText={errors.email && errors.email.message}
              inputRef={register({
                required: 'Provide your email',
                pattern: {
                  value: Regex.email,
                  message: 'Provide a valid email address',
                },
              })}
              placeholder="Enter Email"
            />
            <TextArea
              fullWidth
              label="Message"
              name="message"
              margin="normal"
              labelClassName={classes.textAreaLabel}
              className={classes.textArea}
              rows={8}
              cols={57}
              rowsMax={80}
              colsMax={60}
              ref={exampleRef}
              error={!!errors.message}
              helperText={errors.message && errors.message.message}
              inputRef={register({
                required: 'Enter a message',
                minLength: {
                  value: 1,
                  message: 'Message too short',
                },
              })}
              placeholder=""
            />
            <Button type="submit" variant="contained" color="primary" className={classes.submit}>
              Submit
            </Button>
            <div>
              Mail To:
              <br />
              <b>Ownerfy</b>
              <br />
              2633 Lincoln Blvd Suite #710
              <br />
              Santa Monica, CA 90405
            </div>
          </form>
        ) : (
          <div>
            Thank you! We will respond as soon as possible. Our normal business hours are M - F, 8AM - 5PM PST TEL:
            ‪(424) 272-5816‬
          </div>
        )}
      </Container>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLoginWithFireBase: actions.submitLoginWithFireBase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(withStyles(styles)(Contact)));
